import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegration from "../Common/Axios/axiosIntegration";
import axiosIntegrationGenrateToken from "../Common/Axios/axiosIntegrationGenrateToken";

import {encryptAES } from "../Common/Axios/encrypt";

export const generateTokenApi = async (payload) => {
  const { data = {} } = await axiosIntegration.post(
    API.generate_token,
    {
      partnerCode: payload?.partnerCode,
      accessKey: payload?.accessKey,
      secrateKey: payload?.secrateKey,
    },
    {
      headers: {
        ...axiosIntegration.defaults.headers,
        ClientCode: payload?.ClientCode,
        partnerCode: payload?.partnerCode,
      },
    }
  );
  return data;
};

export const generateTokenEncriptApi = async (payload) => {
  const { data = {} } = await axiosIntegrationGenrateToken.post(
    API.generate_token,
    {
      partnerCode: payload?.partnerCode,
      accessKey: payload?.accessKey,
      secrateKey: payload?.secrateKey,
    },
    {
      headers: {
        ...axiosIntegrationGenrateToken.defaults.headers,
        ClientCode: process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false' ? payload?.ClientCode : encryptAES(payload?.ClientCode),
        partnerCode: process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false' ? payload?.partnerCode : encryptAES(payload?.partnerCode),
      },
    }
  );
  return data;
};
